import * as Common from "./common";

export const Constants = {
    outdoorWallMaxOpeningWidthMetre: 5.5,
    indoorThickWallBreakpointMillimetre: 150,
    indoorThickWallMaxOpeningWidthMetre: 5.5,
    indoorThinWallMaxOpeningWidthMetre: 3.1,
    WallOpeningBeamHeightMetre: 0.1,
    WallOpeningBeamHeightMetreIndoor: 0.1,
    WallOpeningUblockHeightMetre: 0.2,
    IndoorWallOpeningMaxWidthBearing: 2.899,
    IndoorWallOpeningMaxWidthNonBearing: 3.099,
};

export enum BlockType {
    Standard = 0,
    SoundIsolated = 1
}

export interface BuildingIndoorWallSectionModuleModel extends Common.Module {
    WallThicknessOptions: IndoorWallThicknessOption[];
    BlockTypeOptions: BlockTypeOption[];
    HideWidthOptions: boolean;
}

export interface IndoorWallThicknessOption {
    description: string;
    value: number;
}

export interface BlockTypeOption {
    description: string;
    value: number;
}

export interface BuildingOutdoorWallSectionModuleModel extends Common.Module {
}

export interface BuildingWallSection {
    name: string;
    height: number;
    length: number;
    gableEnd: number;
    wallOpenings: WallOpening[];

    showOpenings: boolean;
}

export interface WallOpening {
    name: string;
    width: number;
    height: number;
    quantity: number;
    beam: boolean;
}

export interface OutdoorWallModel {
    wallSections: BuildingWallSection[];
}

export interface IndoorWallModel {
    wallSections: IndoorWallSection[];
}

export interface IndoorWallSection extends BuildingWallSection {
    thickness: number;
    blockType: BlockType;
}
